import React, { useState } from "react";

import { ReactComponent as CommonCommentsIcon } from "@common/assets/images/shared-icons/common-comments-icon.svg";
import Input, { InputElementType } from "@common/components/Input/Input";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

import * as Styles from "./MessageInput.styles";

interface Props {
  placeholder?: string;
  onMessageSend?: (message: string) => void;
  onChange?: (text: string) => void;
  initialValue?: string;
  autoFocus?: boolean;
  testId?: string;
  icontestid?: string;
  sendToUserButton?: JSX.Element;
  sendButtonText: string;
  withoutSendButton?: boolean;
}

export default function MessageInput(props: Props) {
  const [inputValue] = useState(props.initialValue || "");

  return (
    <Styles.Disabled>
      <Input
        autoFocus={props.autoFocus}
        elementType={InputElementType.TEXTAREA}
        placeholder={props.placeholder}
        value={inputValue}
        withSendButton={!props.withoutSendButton}
        actionIcon={
          <Flex
            $justifyContent="center"
            style={{ cursor: "not-allowed" }}
          >
            <CommonCommentsIcon />
          </Flex>
        }
        toggleButton={props.sendToUserButton}
        testId={props.testId}
        icontestid={props.icontestid}
        rows={5}
        sendButtonText={props.sendButtonText}
        disabled={true}
      />
    </Styles.Disabled>
  );
}
